<template>
  <v-layout row wrap class="mt-1">
    <v-flex xs12 md8>
      <course-card v-show="!coursesLoading" v-for="course in courses" :key="course.id" :course-name="course.name" :course-code="course.code" :course-full-name="course.full_name" :course-type="course.type" :course-id="course.id" @click.native="$router.push({name: 'course', params: {id: course.id}})" @reloadCourses="loadCourses" class="mb-3" />
      <h2 v-if="coursesLoading" class="text-xs-center font-weight-light">CARREGANDO CURSOS, AGUARDE!</h2>
      <h2 v-else-if="!courses.length" class="text-xs-center font-weight-light">NÃO HÁ CURSOS PARA MOSTRAR!</h2>
    </v-flex>
    <v-flex xs12 md4>
      <v-form class="course-form px-3 elevation-2" ref="courseForm" v-model="courseValid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert v-model="alert.status" dismissible :type="alert.type">{{ alert.message }}</v-alert>
            <h3 class="mb-2">CADASTRAR NOVO CURSO AO SISTEMA.</h3>
            <hr>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="courseData.name" :counter="60" label="NOME, EX: Computação Forense..." :rules="nameRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="courseData.fullName" :counter="255" label="COMPLETO, EX: Computação Forense & Perícia Digital..." :rules="fullNameRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="courseData.code" :counter="6" label="SIGLA, Ex: CD, PF, BIM..." :rules="codeRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-select box color="black" v-model="courseData.type" hint="TIPO DE CURSO. POS/CAP" :items="courseTypes" item-text="name" item-value="type" label="TIPO DO CURSO" persistent-hint return-object single-line required></v-select>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="success" style="width: 100%;" @click="createCourse()" outline>CADASTRAR</v-btn>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="error" style="width: 100%;" @click="clearForm()" outline>LIMPAR</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import CourseCard from '../../components/CourseCard'
export default {
  name: 'courses',
  components: { CourseCard },
  data() {
    return {
      courses: [],
      coursesLoading: true,
      courseValid: true,
      courseData: {
        name: '',
        fullName: '',
        code: '',
        type: { name: 'PÓS GRADUAÇÃO', type: 'pos' },
      },
      nameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 6) || 'NOME NÃO PODE TER MENOS DE 06 CARACTERES!',
        v => (v && v.length <= 60) || 'NOME NÃO PODE TER MAIS DE 60 CARACTERES!',
      ],
      fullNameRules: [
        v => !!v || 'NOME COMPLETO REQUERIDO!',
        v => (v && v.length >= 16) || 'NOME COMPLETO NÃO PODE TER MENOS DE 16 CARACTERES!',
        v => (v && v.length <= 255) || 'NOME COMPLETO NÃO PODE TER MAIS DE 255 CARACTERES!',
      ],
      codeRules: [
        v => !!v || 'CÓDIGO/SIGLA REQUERIDO!',
        v => (v && v.length >= 2) || 'CÓDIGO/SIGLA NÃO PODE TER MENOS DE 2 CARACTERES!',
        v => (v && v.length <= 6) || 'CÓDIGO/SIGLA NÃO PODE TER MAIS DE 6 CARACTERES!',
      ],
      courseTypes: [
        { name: 'PÓS GRADUAÇÃO', type: 'pos' },
        { name: 'CURSO RAPIDO', type: 'cap' },
      ],
      alert: {
        message: '',
        type: 'success',
        status: false
      }
    }
  },
  methods: {
    loadCourses() {
      this.$http.get('/courses').then(data => {
        this.courses = data.data
        this.coursesLoading = false
      }).catch(err => {
        this.alert.type = 'error'
        this.alert.message = err
        this.alert.status = true
      })
    },
    createCourse() {
      if (this.$refs.courseForm.validate()) {
        this.$http.post('/courses', {
          name: this.courseData.name,
          full_name: this.courseData.fullName,
          code: this.courseData.code,
          type: this.courseData.type.type,
        }).then(data => {
          this.loadCourses()
          this.alert.type = 'success'
          this.alert.message = 'CURSO CADASTRADO!'
          this.alert.status = true
          this.clearForm()
        }).catch(err => {
          this.alert.message = err
          this.alert.type = 'error'
          this.alert.status = true
        })
      } else {
        this.alert.message = 'CAMPOS INVALIDOS!'
        this.alert.type = 'warning'
        this.alert.status = true
      }
    },
    clearForm() {
      this.$refs.courseForm.reset()
      this.courseData.type = { name: 'PÓS GRADUAÇÃO', type: 'pos' }
    },
  },
  created() {
    this.loadCourses()
  }
}
</script>

<style scoped>
  .course-form {
    background-color: #fff;
  }
</style>
